import { Injectable, Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DOCUMENT } from '@angular/common';
import { LoggerService } from '@wdpr/ra-angular-logger';

import { TRAVEL_AGENT, CONFIG_CONSTANTS } from '@finder/shared/constants/app.constants';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { ConfigService } from '@finder/core/config.service';
import { LoadingService } from '@finder/shared/services/loading-service/loading-service.service';
import { isTravelAgent } from '@finder/shared/utils/url/isTravelAgent';

/**
 * Class that provides methods to handle travel agent session stuff
 */
@Injectable()
export class TravelAgentService {

    extendTradeSessionInterval: number;
    extendTradeSessionUrl: string;

    private isValidTradeUrl: boolean;
    private hasSessionCookie: boolean;
    private validTravelAgentFlow: boolean;

    constructor(
        private winRef: WindowRef,
        private cookieService: CookieService,
        private configService: ConfigService,
        private loadingService: LoadingService,
        private logger: LoggerService,
        @Inject(DOCUMENT) private document: Document,
    ) { }

    init() {
        this.isValidTradeUrl = isTravelAgent(this.winRef.nativeWindow.location.pathname);
        this.hasSessionCookie = this.cookieService.get(TRAVEL_AGENT.cookieName) ? true : false;
        this.validTravelAgentFlow = this.isValidTradeUrl && this.hasSessionCookie;
        this.extendTradeSessionInterval = this.configService.getValue('travelAgentSessionExtendInterval');
        this.extendTradeSessionUrl =
            `${this.configService.getValue(CONFIG_CONSTANTS.apiUrlKey)}${this.configService.getValue('travelAgentSessionUrl')}`;
        if (this.validTravelAgentFlow) {
            this.document.addEventListener('requestError', this.reloadPage.bind(this), true);
        }
    }

    isValidTradeFlow() {
        return this.validTravelAgentFlow;
    }

    isValidTravelAgentUrl() {
        return this.isValidTradeUrl;
    }

    showErrorIfCookieIsMissing() {
        const cookieIsMissing = this.isValidTradeUrl && !this.hasSessionCookie;
        if (cookieIsMissing) {
            this.setSessionError();

            return true;
        }

        return false;
    }

    setSessionError() {
        this.logger.error('Travel Agent Error: invalid session');
        this.loadingService.setErrorState({
            name: 'Travel Agent Session Error',
            status: 599
        });
        this.loadingService.setLoadingState(true);
    }

    reloadPage() {
        // remove session cookie if exists because there's an error
        this.cookieService.delete(TRAVEL_AGENT.cookieName, '/');
        // Reload the page to show error
        this.winRef.nativeWindow.location.reload();
    }
}
